"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_drive_view_controller_1 = __importDefault(require("./student-drive-view.controller"));
var student_drive_report_card_module_1 = __importDefault(require("./report-card/student-drive-report-card.module"));
var student_drive_view_html_1 = __importDefault(require("./student-drive-view.html"));
var time_1 = require("../../../common/helpers/time");
var drive_types_1 = require("../../../common/types/drive.types");
function getCancellationRules(UsersModel, $stateParams, UserService) {
    return UsersModel.getStudentCancellationRules($stateParams.id, UserService.getCurrentUser().id).then(function (response) {
        return response;
    });
}
getCancellationRules.$inject = ["UsersModel", "$stateParams", "UserService"];
function getPickupLocations($stateParams, UsersModel) {
    return UsersModel.getStudentPickupLocationsByDriveSession($stateParams.id).then(function (response) {
        response.pickuplocations.map(function (location) {
            location.name = location.name + " " + location.address.street;
            return location;
        });
        response.dropofflocations.map(function (location) {
            location.name = location.name + " " + location.address.street;
            return location;
        });
        return response;
    });
}
getPickupLocations.$inject = ["$stateParams", "UsersModel"];
function getDriveSession($stateParams, DrivesModel) {
    return DrivesModel.getDriveByID($stateParams.id).then(function (response) {
        var drive = structuredClone(response.drive);
        var _a = (0, drive_types_1.formatDriveForDisplay)(drive), sessionLengthHours = _a.sessionLengthHours, sessionLengthMinutes = _a.sessionLengthMinutes;
        var driveDateTime = (0, time_1.dateTimeStringToDate)(response.drive.drive_date + " " + response.drive.start_time);
        drive.drive_date = (0, time_1.formatDateTime)(driveDateTime, "MM/DD/YYYY");
        drive.start_time = (0, time_1.formatDateTime)(driveDateTime, "h:mm A");
        return Object.assign(drive, { sessionLengthHours: sessionLengthHours, sessionLengthMinutes: sessionLengthMinutes });
    });
}
getDriveSession.$inject = ["$stateParams", "DrivesModel"];
function getCurrentUser(UserService, UsersModel) {
    var currentUser = UserService.getCurrentUser();
    return UsersModel.getStudentByID(currentUser.id).then(function (response) {
        return response;
    });
}
getCurrentUser.$inject = ["UserService", "UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.drives.view", {
        url: "/view/:id",
        controller: student_drive_view_controller_1.default,
        controllerAs: "vm",
        template: student_drive_view_html_1.default,
        resolve: {
            driveSession: getDriveSession,
            student: getCurrentUser,
            locations: getPickupLocations,
            cancellationRules: getCancellationRules,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.student,
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.drives.view", [student_drive_report_card_module_1.default.name])
    .config(config)
    .controller("StudentDrivesViewController", student_drive_view_controller_1.default);
